<template lang="pug">

    form.ui.form(v-on:submit.prevent="submit()")

        //- Step-Navigation
        step-navigation(v-bind:step='2')

        //- Formular

        //- Allgemeine Angaben
        .ui.top.attached.header Allgemeine Angaben:
        .ui.bottom.attached.segment
            address-general-information-form(
                ref="generalInformationForm"
                v-bind:country-models='countries'
                v-bind:hide-company='true'
                v-model='address'
            )

        //- Ansprechpartner
        .ui.top.attached.header Ansprechpartner:
        .ui.bottom.attached.segment
            person-form(
                ref="personForm"
                v-bind:hide-address='true'
                v-bind:hide-company='true'
                v-model="person"
            )

        //- Zusätzliche Angaben
        .ui.top.attached.header Zusätzliche Angaben:
        .ui.bottom.attached.segment
            address-additional-information-form(v-model='address' ref='additionalInformationForm')

        //- Adresstyp
        .ui.top.attached.header Adresstyp:
        .ui.bottom.attached.segment
            address-types-form(
                ref="typesForm"
                v-bind:hide-billing-address-warning="true"
                v-bind:hide-correspondence-address-warning="true"
                v-bind:hide-shipping-address-warning="true"
                v-bind:lock-is-billing-address="true"
                v-bind:lock-is-correspondence-address="true"
                v-bind:lock-is-shipping-address="true"
                v-bind:lock-is-default-billing-address="true"
                v-bind:lock-is-default-correspondence-address="true"
                v-bind:lock-is-default-shipping-address="true"
                v-bind:is-default-billing-address="true"
                v-bind:is-default-correspondence-address="true"
                v-bind:is-default-shipping-address="true"
                v-model='address'
            )

        //- Avis
        .ui.top.attached.header Avis:
        .ui.bottom.attached.segment
            address-advice-form(v-model='advice' ref="adviceForm")

        .ui.two.columns.grid
            .left.aligned.column
                router-link.ui.labeled.icon.button(v-bind:to='{ name: "companies/create" }' exact)
                    i.chevron.left.icon
                    |  Zurück
            .right.aligned.column
                a.ui.labeled.icon.button(v-on:click='cancel()')
                    i.remove.icon
                    |  Abbrechen
                button.ui.right.labeled.primary.icon.button
                    i.chevron.right.icon
                    |  Weiter

</template>

<script>
    import * as R from 'ramda'
    import store from '@/store/index'
    import AddressAdditionalInformationForm from '@/components/addresses/form/AdditionalInformation.vue'
    import AddressAdviceForm from '@/components/addresses/form/Advice.vue'
    import AddressGeneralInformationForm from '@/components/addresses/form/GeneralInformation.vue'
    import AddressTypesForm from '@/components/addresses/form/Types.vue'
    import PersonForm from '@/components/persons/Form.vue'
    import StepNavigation from '@/components/companies/StepNavigation.vue'

    //noinspection JSUnusedGlobalSymbols,JSUnusedLocalSymbols
    export default {
        name: 'companies-create-step2-view',

        components: {
            AddressAdditionalInformationForm, AddressAdviceForm, AddressGeneralInformationForm,
            AddressTypesForm, PersonForm, StepNavigation
        },

        beforeRouteEnter(to, from, next) {
            // Laender laden
            return store.dispatch('countries/loadAll').then(next)
        },

        computed: {

            address: {
                get() { return this.$store.getters['companies/draft'].address || {} },
                set(value) { this.model = { ...this.model, address: value } }
            },

            advice: {
                get() { return this.address.advice || '' },
                set(value) { this.address = { ...this.address, advice: value } }
            },

            companies() {
                return [{ ...this.model }]
            },

            countries() {
                return store.getters['countries/all']
            },

            model: {
                get() { return this.$store.getters['companies/draft'] },
                set(value) { this.$store.commit('companies/REPLACE_DRAFT', { draft: value }) }
            },

            person: {
                get() { return this.$store.getters['companies/draft'].person || {} },
                set(value) { this.model = { ...this.model, person: value } }
            },

        },

        created() {
            this.$scrollTo('body')
        },

        watch: {
            'address.firm'(firm) {
                // Bezeichnung mit dem Firmennamen vorbelegen
                this.address = { ...this.address, name: firm || '' }
            }
        },

        methods: {

            cancel() {
                this.$router.push({ name: 'companies' })
            },

            next() {
                this.$router.push({ name: 'companies/create/step3' })
            },

            submit() {
                this.validate().then(R.ifElse(R.equals(true), this.next, this.$scrollToErrorAndFocus))
            },

            validate() {
                return Promise.all([
                    this.$refs.additionalInformationForm.validate(),
                    this.$refs.adviceForm.validate(),
                    this.$refs.generalInformationForm.validate(),
                    this.$refs.personForm.validate(),
                    this.$refs.typesForm.validate()
                ]).then(R.all(R.equals(true)))
            }
        }

    }

</script>
